import { InvestorProfileType } from '@/api/backend/types';
import { Container } from '@/components/container';
import { SubNavContainer } from '@/components/sub-nav-container';
import { getAvatarInitials, getLocalizedName } from '@/lib/utils';
import { Avatar, AvatarFallback, AvatarImage, TabsList, TabsRoot, TabsTrigger } from '@opaz/ui-components';
import { createFileRoute, Link, Outlet, useLocation, useNavigate } from '@tanstack/react-router';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ProfileContext } from '../route';

export const Route = createFileRoute('/_auth/profile/investor/_layout')({
  component: RouteComponent,
  context: () => {
    return {
      getBreadcrumbData: () => ({
        id: null,
        translationKey: 'breadcrumbs.profile',
      }),
    };
  },
});

function RouteComponent() {
  const { profile } = useContext(ProfileContext);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const tabValue = location.pathname.split('/').pop() as string;
  const investorProfile = profile as InvestorProfileType;

  if (investorProfile.type !== 'INVESTOR') {
    navigate({ to: '/profile/company' });
  }

  return (
    <>
      <SubNavContainer>
        <div className="flex gap-4 items-center">
          <Avatar size="lg" status="online">
            <AvatarImage src="/avatars/01.png" />
            <AvatarFallback>
              {getAvatarInitials(getLocalizedName(investorProfile.nameEn, investorProfile.nameAr, i18n.language))}
            </AvatarFallback>
          </Avatar>

          <div className="flex flex-col">
            <p className="text-[32px] font-bold text-foreground">
              {getLocalizedName(investorProfile.nameEn, investorProfile.nameAr, i18n.language)}
            </p>
            <p className="text-xl text-muted-foreground">{investorProfile.identifier}</p>
          </div>
        </div>
      </SubNavContainer>

      <Container>
        <TabsRoot value={tabValue} variant="toggle" width="full" dir={i18n.dir()}>
          <TabsList className="mb-12">
            <Link className="w-full" to="/profile/investor/personal-information">
              <TabsTrigger value="personal-information">
                {t('profile.investor.tabs.personalInformation.title')}
              </TabsTrigger>
            </Link>

            <Link className="w-full" to="/profile/investor/notification-settings">
              <TabsTrigger value="notification-settings">
                {t('profile.investor.tabs.notificationSettings.title')}
              </TabsTrigger>
            </Link>
          </TabsList>
        </TabsRoot>

        <Outlet />
      </Container>
    </>
  );
}
